import React from 'react';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import ICellProps, { ITranchRow } from './ICellProps';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => (
  tranche.couponType
    ? tranche.couponType.name
    : '-'
);

const CouponTypeCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="CouponTypeCell"
    className={ alignStyles.alignCenter }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default CouponTypeCell;
